import React from 'react'
import { useState,useEffect } from 'react';
import ReelsFunctions from '../../../../../functions/public/reels';
import FormTextarea from '../../../../forms/formTextarea';
import ProductSelector from './productSelector';
import ApiUrl from '../../../../../configTools/apiUrl';
import Button from '../../../../forms/blackfillButton';
import ViewPop from './viewPop';

const Index = ({username}) => {
    const User = JSON.parse(localStorage.getItem("user-info"));
    const [uploadedFile,setUploadedFile] = useState('');
    const [showLoading,setShowLoading] = useState(false);
    const [showProductSelector, setShowProductSelector] = useState(false);
    const [selectedProduct,setSelectedProduct] = useState({
        id:0,
        title:"",
        price:0,
        compareatprice:0,
        image:"",
        slug:"",
        state:0,
        pin:0,
        sold:0
    })
    const [discription,setDiscription] = useState('');
    const [reels,setReels] = useState([]);
    const [openedReel,setOpenedReel] = useState(0);
    const reset = ()=>{
        setSelectedProduct({
            id:0,
            title:"",
            price:0,
            compareatprice:0,
            image:"",
            slug:"",
            state:0,
            pin:0,
            sold:0
        });
        setDiscription('');
        setShowProductSelector(false);
        setShowLoading(false);
        setUploadedFile('');
    }
    useEffect(()=>{
        ReelsFunctions.reelGetUsername(username,0,setReels);
    },[])
    useEffect(()=>{
        if(selectedProduct.id != 0){
            setShowProductSelector(false);
        }
    },[selectedProduct])
  return (
    <>
        <div className='profile_reels_wrapper'>
            <div className='profile_reels_container'>
                {User &&
                <>
                {User.username === username &&
                    <div className='profile_reels_addnew_wrapper'>
                        <label style={{cursor:"pointer"}}>
                            <div className='profile_reels_addnew_container'>
                                <h5>Create</h5>
                            </div>
                            <input type="file" style={{display:"none"}} onChange={(e)=>{
                                ReelsFunctions.videoUpload(e,setUploadedFile,setShowLoading);
                            }}/>
                        </label>
                    </div>
                }
                </>
                }
                {reels.map((item,index)=>{
                    return(
                        <div className='profile_reels_item_wrapper' key={index}>
                            <div className='profile_reels_item_container' onClick={()=>{setOpenedReel(item.id)}}>
                                <video src={ApiUrl.API_URL_Video_HD+item.video}></video>
                            </div>
                        </div>
                    )
                })

                }
            </div>
        </div>
        {showLoading &&
            <div className='reels_information_wrapper'>
                <div className='reels_information_container'>
                    {uploadedFile === '' &&
                        <div className='reels_information_loading_container'>
                            <div className='loader'></div>
                        </div>
                    }
                    {uploadedFile !== '' &&
                        <div className='reels_information_form_container'>
                            {!showProductSelector &&
                                <>
                                    <FormTextarea Lable='Discription' Placeholder='Enter discription' Value={discription} setValue={setDiscription}/>
                                    {selectedProduct.id === 0 &&
                                        <div className='reels_information_addproduct_wrapper' onClick={
                                            ()=>{
                                                setShowProductSelector(true);
                                            }
                                        }>
                                            <div className='reels_information_addproduct_container'>
                                                <h4>Add a product</h4>
                                            </div>
                                        </div>
                                    }
                                    {selectedProduct.id !== 0 &&
                                        <div className='reels_information_selectedproduct_wrapper'>
                                            <div className='reels_information_selectedproduct_container'>
                                                <div className='reels_information_selectedproduct_details'>
                                                    <div style={{
                                                        width: "100px",
                                                        paddingTop: "100px",
                                                        borderRadius: "5px",
                                                        position: "relative",
                                                        backgroundImage:`url(${ApiUrl.API_URL_Image_Thumbnail+selectedProduct.image})`,
                                                        backgroundSize: 'cover',
                                                        backgroundRepeat: 'no-repeat',
                                                        backgroundPosition: 'center'
                                                    }}></div>
                                                    <div className='reels_information_selectedproduct_headings'>
                                                        <h5>{selectedProduct.title}</h5>
                                                        <p onClick={()=>{
                                                            setSelectedProduct({
                                                                id:0,
                                                                title:"",
                                                                price:0,
                                                                compareatprice:0,
                                                                image:"",
                                                                slug:"",
                                                                state:0,
                                                                pin:0,
                                                                sold:0
                                                            })
                                                        }}>remove</p>
                                                    </div>
                                                </div>
                                                <div className='reels_information_selectedproduct_price'>
                                                    <p>
                                                        {selectedProduct.compareatprice !== 0 && selectedProduct.compareatprice > selectedProduct.price && selectedProduct.compareatprice !== undefined &&
                                                            <><b>Rs.{selectedProduct.compareatprice}/-</b><br></br></>
                                                        }
                                                        Rs.{selectedProduct.price}/-
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <Button Value={"Update"} Action={()=>{
                                        ReelsFunctions.reelUpload({
                                            video: uploadedFile,
                                            discription: discription,
                                            productslug: selectedProduct.slug
                                        },(res)=>{
                                            if(res.success){
                                                reset();
                                                ReelsFunctions.reelGetUsername(username,0,(Value)=>{
                                                    setReels(Value);
                                                    setOpenedReel(res.id);
                                                });
                                            }
                                            else{
                                                console.log(res.responce)
                                            }
                                        });

                                    }}/>
                                </>
                            }
                            {showProductSelector &&
                                <ProductSelector username={username} setSelectedProduct={setSelectedProduct}/>
                            }
                        </div>
                    }
                    <button className='reels_information_closeButton' onClick={()=>{
                        reset();
                    }}>X</button>
                </div>
            </div>
        }
        {openedReel !== 0 &&
            reels.map((item,index)=>{
                return(
                    <div key={index}>
                        {item.id == openedReel &&
                            <ViewPop reel={item} setSelectedReel={setOpenedReel}/>
                        }
                    </div>
                )
            })
        }
    </>
  )
}

export default Index
